//import { push } from "connected-react-router";

// import { decodeJwt, getExpiryMins } from "../../utils/jwt";
// import makeApiRequest from "../../utils/axios/new-axios";
// import {
//   SESSION_TIMEOUT_MINS,
//   AUTH_REFRESH_ACCESS_TOKEN_URL
// } from "../../config";

import {
  LOGIN,
  LOGOUT,
  UPDATE_ACCESS_TOKEN,
  UPDATE_IS_REFRESHING_TOKEN
} from "../types";

import history from "../history";

import { getSessionId, setSessionId } from "../../utils/storage"

export const loginUser = user => ({
  type: LOGIN,
  user
});

export const logoutUser = (reason) => {
  return async (dispatch, getState) => {
    // *** MANUALLY CLEARING THE LOCAL STORAGE TO AVOID THE DELAY FROM REDUX PERSIST ***
    const sessionId = getSessionId();
    localStorage.clear();
    setSessionId(sessionId);
    const returnUrl = `${history?.location?.pathname}${history?.location?.search}`;
    // *** DISPATCH ONLY AFTER CLEARING TO PREVENT RERENDEING HOME WHILE LOGOUT ***
    // *** ALSO DISPATCH ONLY AFTER GETTING THE HISTORY INFO ***    
    dispatch({ type: LOGOUT });

    if (reason && reason === "force_logout") {
      history.push(`/?retUrl=${encodeURIComponent(returnUrl)}`);
    } else {
      history.push("/");
    }

  };
};

//action to check if the token is valid. if not valid, logout.
//if valid, check if expiring, then trigger refresh access token
//called from the PrivateRoute whenever page changes
// export const checkAndRefreshAccessToken = () => {
//   return async (dispatch, getState) => {
//     const auth = getState().auth;
//     const minsToExpire = getExpiryMins(auth.expiry);

//     if (minsToExpire <= 0) {
//       //session expired
//       dispatch(logoutUser());
//     } else if (minsToExpire <= SESSION_TIMEOUT_MINS) {
//       //renew jwtexport default function
//       //check if it is refreshing already
//       if (!auth.isRefreshing) {
//         try {
//           dispatch(updateIsRefreshingToken(true));
//           const id = getState().auth.id;
//           const axiosInstance = new Axios();
//           await axiosInstance
//             .request({
//               url: AUTH_REFRESH_ACCESS_TOKEN_URL.url,
//               method: AUTH_REFRESH_ACCESS_TOKEN_URL.method,
//               data: {
//                 id: id,
//                 sessionId: auth.sessionId
//               }
//             })
//             .then(response => {
//               const accessToken = response.data.accessToken;
//               const decoded = decodeJwt(accessToken);
//               dispatch(
//                 updateAccessToken({
//                   accessToken: accessToken,
//                   expiry: decoded.exp,
//                   sessionId: auth.sessionId
//                 })
//               );
//               dispatch(updateIsRefreshingToken(false));
//             })
//             .catch(error => {
//               console.log("axios error ", error);
//               dispatch(updateIsRefreshingToken(false));
//               dispatch(logoutUser());
//             });
//         } catch (error) {
//           console.log("try catch error ", error);
//           dispatch(updateIsRefreshingToken(false));
//           dispatch(logoutUser());
//         }
//       }
//     }
//   };
// };

export const updateIsRefreshingToken = isRefreshing => {
  return {
    type: UPDATE_IS_REFRESHING_TOKEN,
    isRefreshing
  };
};

export const updateAccessToken = token => {
  return {
    type: UPDATE_ACCESS_TOKEN,
    accessToken: token.accessToken,
    expiry: token.expiry,
    sessionId: token.sessionId
  };
};
